import * as React from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

export interface OwnProps {}

interface StateProps {}

interface DispatchProps {
    updateQueryString: Function;
}

type IProps = StateProps & DispatchProps & OwnProps;

export class TimesheetEntriesDeleteDropdownItem extends React.PureComponent<
    IProps
> {
    handleClick = () => {
        this.props.updateQueryString({
            deleteTimesheetEntriesModal: true
        });
    };

    render() {
        return <Dropdown.Item text="Delete" onClick={this.handleClick} />;
    }
}

export default connect<StateProps, DispatchProps, OwnProps>(
    null,
    { updateQueryString }
)(TimesheetEntriesDeleteDropdownItem);
